import React from "react";
import { getImagePath } from "../utilities";

export default props => {
  const base = process.env.BACKEND_URL ? process.env.BACKEND_URL : "";
  const { uri, size, width, height } = props;
  return (
    <div
      style={{
        backgroundImage: `url(${base}${getImagePath(uri)})`,
        backgroundSize: size,
        width: width,
        height: height
      }}
    />
  );
};
